<template>
  <div ref="target" class="news-sort">
    <div class="left">
      <i></i>
      <RouterLink target="_blank" to="/video?firstCate=189"
        >卫生副高级职称</RouterLink
      >
    </div>
    <div class="right">
      <RouterLink target="_blank" to="#/video?firstCate=189">
        <span>更多</span>
        <el-icon><ArrowRight /></el-icon>
      </RouterLink>
    </div>
  </div>
  <div class="news-tabs">
    <ShTabs v-model="activeName">
      <ShTabsPanel label="临床医学类" name="linchuangyixue">
        <FuGaoLinChuang
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
      /></ShTabsPanel>
      <ShTabsPanel label="临床口腔类" name="linchuangkouqiang"
        ><FuGaoKouQiang
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="医学中医类" name="linchuangzhongyi">
        <FuGaoZhongYi
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="临医检验类" name="linyijianyan">
        <FuGaoJianYan
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
      /></ShTabsPanel>
      <ShTabsPanel label="护理学类" name="hulixue"
        ><FuGaoHuLi
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="临医检验技术" name="jianyanjishu"
        ><FuGaoJianYanJiShu
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="药学类" name="yaoxuelei"
        ><FuGaoYaoXue
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="其他技术类" name="qitajishu"
        ><FuGaoYiXueJiShu
          :policyList="policyList"
          :noticeList="noticeList"
          :bannerList="bannerList"
      /></ShTabsPanel>
    </ShTabs>
  </div>
</template>

<script>
import { ref } from "vue";
import { findFuGaoNews, findNewsBanner } from "@/api/news";
import { useLazyNews, useLazyNewsBanner } from "@/hooks";
import FuGaoZhongYi from "@/views/news/compontents/fugaoji/fugaozhongyi-news";
import FuGaoLinChuang from "@/views/news/compontents/fugaoji/fugaolinchuang-news";
import FuGaoKouQiang from "@/views/news/compontents/fugaoji/fugaokouqiang-news";
import FuGaoYiXueJiShu from "@/views/news/compontents/fugaoji/fugaoyixuejishu-news";
import FuGaoYaoXue from "@/views/news/compontents/fugaoji/fugaoyaoxue-news";
import FuGaoJianYanJiShu from "@/views/news/compontents/fugaoji/fugaojianyanjishu-news";
import FuGaoJianYan from "@/views/news/compontents/fugaoji/fugaojianyan-news";
import FuGaoHuLi from "@/views/news/compontents/fugaoji/fugaohuli-news";

export default {
  name: "GaoJiNewsList",
  components: {
    FuGaoZhongYi,
    FuGaoLinChuang,
    FuGaoKouQiang,
    FuGaoYiXueJiShu,
    FuGaoYaoXue,
    FuGaoJianYanJiShu,
    FuGaoJianYan,
    FuGaoHuLi,
  },
  setup() {
    const activeName = ref("linchuangyixue");
    const target = ref(null);
    const { notice, policy } = useLazyNews(target, () =>
      findFuGaoNews({ chID: 189 })
    );
    const { bannerList } = useLazyNewsBanner(target, () =>
      findNewsBanner({ chID: [189] })
    );
    return {
      activeName,
      bannerList,
      target,
      noticeList: notice,
      policyList: policy,
    };
  },
};
</script>

<style lang="less" scoped>
.news-sort {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  background: rgb(244, 244, 244);

  .left {
    i {
      display: inline-block;
      width: 3px;
      height: 20px;
      background: @shColor;
      margin-right: 15px;
    }
    a {
      font-size: 22px;
      &:hover {
        color: @shColor;
      }
    }
  }
  .right {
    margin-right: 10px;
    :hover {
      color: @shColor;
    }
    a {
      display: flex;
      align-items: center;
      color: #999;
    }
  }
}
.news-tabs {
  .news-list {
    height: 500px;
    //background: #f0e5e5;
    display: flex;
    justify-content: space-between;
    .left {
      width: 400px;
      height: 500px;
      display: flex;
      flex-direction: column;
      .top {
        width: 400px;
        height: 240px;
        .top-carousel {
          display: inline-block;
          width: 360px;
          height: 130px;
          margin-left: 20px;
          margin-right: 20px;
          margin-top: 15px;
          border-radius: 5px;
          a {
            img {
              border-radius: 5px;
            }
          }
          .bottom-carousel {
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            height: 80px;
            width: 360px;

            .carousel-top {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 40px;
              width: 360px;
            }
            .carousel-bottom {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 40px;
              width: 360px;
            }
          }
        }
      }

      .bottom {
        width: 400px;
        height: 250px;
        .recommend {
          display: flex;
          height: 50px;
          align-items: center;
          justify-content: space-between;
          background: rgb(244, 244, 244);
          h3 {
            margin-left: 10px;
          }
          .more {
            a {
              display: flex;
              align-items: center;
              margin-right: 10px;
              color: #999;
              &:hover {
                color: @shColor;
              }
            }
          }
        }
        .recommend-cate {
          display: flex;
          height: 210px;
          justify-content: space-between;
          .cate-left {
            width: 195px;
            position: relative;
            border: 1px solid rgb(244, 244, 244);
            a {
              width: 195px;
              margin-right: 5px;

              img {
                width: 195px;
                height: 120px;
              }
              i {
                display: inline-block;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 38px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                background: @shColor;
              }
              span {
                margin: 5px 5px 5px 5px;
                &:hover {
                  color: @shColor;
                }
              }
            }
            .cate-desc {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              h3 {
                width: 80px;
                margin-left: 10px;
                color: #fd7502;
              }
              a {
                display: inline-block;
                height: 22px;
                margin-bottom: 5px;
                width: 80px;
              }
            }
          }
          .cate-right {
            width: 195px;
            position: relative;
            border: 1px solid rgb(244, 244, 244);
            a {
              width: 195px;
              margin-right: 5px;

              img {
                width: 195px;
                height: 120px;
              }
              i {
                display: inline-block;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 38px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                background: @shColor;
              }
              span {
                margin: 5px 5px 5px 5px;
                &:hover {
                  color: @shColor;
                }
              }
            }
            .cate-desc {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              h3 {
                width: 80px;
                margin-left: 10px;
                color: #fd7502;
              }
              a {
                display: inline-block;
                width: 80px;
              }
            }
          }
        }
      }
    }
    .middle {
      margin-top: 15px;
      width: 400px;
      overflow: hidden;
      border: 1px solid rgb(244, 244, 244);
      .policy {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        background: rgb(244, 244, 244);
        div {
          display: flex;
          align-items: center;
          i {
            display: inline-block;
            width: 3px;
            height: 20px;
            background: @shColor;
          }
          h3 {
            margin-left: 10px;
          }
        }
        a {
          display: flex;
          align-items: center;
          color: #999;
          &:hover {
            color: @shColor;
          }
        }
      }
      .policy-news {
        ul {
          width: 390px;
          padding-top: 10px;
          padding-bottom: 10px;
          margin-left: 10px;
          & :hover {
            color: @shColor;
          }
          a {
            width: 390px;
            display: inline-block;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
    .right {
      margin-top: 15px;
      width: 400px;

      .notice {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        overflow: hidden;
        border: 1px solid rgb(244, 244, 244);
        background: rgb(244, 244, 244);
        div {
          display: flex;
          align-items: center;
          i {
            display: inline-block;
            width: 3px;
            height: 20px;
            background: @shColor;
          }
          h3 {
            margin-left: 10px;
          }
        }
        a {
          display: flex;
          align-items: center;
          color: #999;
          &:hover {
            color: @shColor;
          }
        }
      }
      .notice-news {
        height: 185px;
        padding-top: 5px;
        ul {
          width: 400px;
          padding-top: 5px;
          padding-bottom: 5px;
          margin-left: 10px;
          & :hover {
            color: @shColor;
          }
          a {
            display: inline-block;
            width: 400px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      .notes {
        .notice {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 50px;
          background: rgb(244, 244, 244);
          div {
            display: flex;
            align-items: center;
            i {
              display: inline-block;
              width: 3px;
              height: 20px;
              background: @shColor;
            }
            h3 {
              margin-left: 10px;
            }
          }
          a {
            display: flex;
            align-items: center;
            color: #999;
            &:hover {
              color: @shColor;
            }
          }
        }
        .data-recomend {
          display: flex;
          justify-content: space-between;
          height: 210px;
          .cate-left {
            width: 195px;

            position: relative;
            border: 1px solid rgb(244, 244, 244);
            a {
              width: 195px;
              margin-right: 5px;

              img {
                width: 195px;
                height: 120px;
              }
              i {
                display: inline-block;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 38px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                background: @shColor;
              }
              span {
                margin: 5px 5px 5px 5px;
                &:hover {
                  color: @shColor;
                }
              }
            }
            .cate-desc {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              h3 {
                width: 80px;
                margin-left: 10px;
                color: #fd7502;
              }
              a {
                display: inline-block;
                height: 22px;
                margin-bottom: 5px;
                width: 80px;
              }
            }
          }
          .cate-right {
            width: 195px;
            position: relative;
            border: 1px solid rgb(244, 244, 244);
            a {
              width: 195px;
              margin-right: 5px;

              img {
                width: 195px;
                height: 120px;
              }
              i {
                display: inline-block;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 38px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                background: @shColor;
              }
              span {
                margin: 5px 5px 5px 5px;
                &:hover {
                  color: @shColor;
                }
              }
            }
            .cate-desc {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              h3 {
                width: 80px;
                margin-left: 10px;
                color: #fd7502;
              }
              a {
                display: inline-block;
                width: 80px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
